/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_UndoInputs */

const en_btn_undo = /** @type {(inputs: Btn_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo`)
};

/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Btn_UndoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const btn_undo = /** @type {((inputs?: Btn_UndoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_UndoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_undo(inputs)
});